/**
 * Utility functions for tracking and marketing parameters
 */

/**
 * Gets the value of a cookie by name
 */
export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(';');
  
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  
  return null;
}

/**
 * Extracts UTM parameters from URL search params
 */
export interface UTMParameters {
  utm_campaign?: string;
  utm_term?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
}

export function extractUTMParameters(searchParams: URLSearchParams): UTMParameters {
  const utmParams: UTMParameters = {};
  
  const utmKeys: (keyof UTMParameters)[] = [
    'utm_campaign',
    'utm_term',
    'utm_source',
    'utm_medium',
    'utm_content'
  ];
  
  utmKeys.forEach(key => {
    const value = searchParams.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });
  
  return utmParams;
}

/**
 * Gets the Marketo tracking cookie value
 */
export function getMarketoCookie(): string | null {
  return getCookie('_mkto_trk');
}

/**
 * Combined tracking data for survey submissions
 */
export interface TrackingData {
  marketoId: number | null;
  marketoCookie: string | null;
  utmParameters: UTMParameters;
}



